function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect } from 'react';
import en from './locales/RecordEditorDrawer.en.json';
import AdditionalIntl from '../I18n/AdditionalIntl/AdditionalIntl';
import Drawer from '../Drawer/Drawer';
import RecordEditorDrawerContent from './RecordEditorDrawerContent';
import normalizeLocaleData from '../utils/i18n/normalizeLocaleData';
import useBooleanState from '../hooks/useBooleanState';
import noop from '../utils/noop';
var I18N_PREFIX = '@dm/components.record-editor-drawer';
var MESSAGES = normalizeLocaleData(en, I18N_PREFIX);
export function makeI18nKey(key) {
  return I18N_PREFIX + '.' + key;
}
export default function RecordEditorDrawer(_ref) {
  var onClose = _ref.onClose,
    _ref$onDirty = _ref.onDirty,
    onDirty = _ref$onDirty === void 0 ? noop : _ref$onDirty,
    onError = _ref.onError,
    onSave = _ref.onSave,
    open = _ref.open,
    activitiesApi = _ref.activitiesApi,
    canAddAnother = _ref.canAddAnother,
    code = _ref.code,
    focusId = _ref.focusId,
    instrumentId = _ref.instrumentId,
    loggerName = _ref.loggerName,
    loggerProject = _ref.loggerProject,
    Messages = _ref.Messages,
    recordId = _ref.recordId,
    screenId = _ref.screenId,
    screenName = _ref.screenName,
    successSnackbar = _ref.successSnackbar,
    _ref$suppressCloseOnD = _ref.suppressCloseOnDirty,
    suppressCloseOnDirty = _ref$suppressCloseOnD === void 0 ? false : _ref$suppressCloseOnD,
    userId = _ref.userId;
  var _useBooleanState = useBooleanState(open),
    _useBooleanState2 = _slicedToArray(_useBooleanState, 3),
    forceOpen = _useBooleanState2[0],
    setForceOpenTrue = _useBooleanState2[1],
    setForceOpenFalse = _useBooleanState2[2];
  useEffect(function () {
    if (open) {
      setForceOpenTrue();
    }
  }, [open, setForceOpenTrue]);
  useEffect(function () {
    if (suppressCloseOnDirty) {
      if (open) {
        setForceOpenTrue();
      } else {
        setForceOpenFalse();
      }
    }
  }, [open, setForceOpenTrue]);
  var handleCollapse = useCallback(function () {
    if (suppressCloseOnDirty) {
      setForceOpenFalse();
    }
    onClose();
  }, [setForceOpenFalse, onClose]);
  return /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: MESSAGES,
    path: "RecordEditorDrawer/locales/RecordEditorDrawer",
    namespace: I18N_PREFIX
  }, /*#__PURE__*/React.createElement(Drawer, {
    allowBodyScroll: false,
    forceOpen: forceOpen,
    hasCollapseButton: false,
    hasExpandButton: false,
    initialCollapsed: suppressCloseOnDirty ? !open : true,
    name: makeI18nKey('name'),
    onCollapse: handleCollapse,
    onExpand: setForceOpenFalse,
    show: true,
    width: "35rem",
    forceClose: suppressCloseOnDirty
  }, function (toggleCollapse) {
    return /*#__PURE__*/React.createElement(RecordEditorDrawerContent, {
      onClose: toggleCollapse,
      onError: onError,
      onSave: onSave,
      onDirty: onDirty,
      activitiesApi: activitiesApi,
      canAddAnother: canAddAnother,
      code: code,
      focusId: focusId,
      instrumentId: instrumentId,
      loggerName: loggerName,
      loggerProject: loggerProject,
      Messages: Messages,
      recordId: recordId,
      screenId: screenId,
      screenName: screenName,
      successSnackbar: successSnackbar,
      suppressCloseOnDirty: suppressCloseOnDirty,
      userId: userId
    });
  }));
}